import { useNavigate } from '@tanstack/react-router';
import { useEffect, type ReactNode } from 'react';
import { useAuth } from '../lib/auth';
import { TermsGate } from './Legal';

export function Splash() {
  return <div className="center"><span className="wordmark">Lineage</span></div>;
}

/** Redirects signed-out visitors to the sign-in screen, remembering where they were going. */
export function Protected({ children }: { children: ReactNode }) {
  const { user, ready } = useAuth();
  const nav = useNavigate();
  useEffect(() => {
    if (ready && !user) void nav({ to: '/sign-in', search: { redirect: window.location.pathname } });
  }, [ready, user, nav]);
  if (!ready || !user) return <Splash />;
  return <TermsGate>{children}</TermsGate>;
}
